import { useContext } from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { CookieContext } from "../../components/context/CookieContext";

export default function Optout() {
  const { cookiePermission, setCookiePermission } = useContext(CookieContext);

  const toggleCookiePermission = () => {
    const newPermission = cookiePermission === "1" ? "0" : "1";
    setCookiePermission(newPermission);
    Cookies.set("px_cookie_permission", newPermission, { expires: 365 });
  };

  return (
    <section className="single-page py-12">
      <div className="mx-auto max-w-6xl px-6">
        <div className="grid gap-10 lg:grid-cols-3">

          {/* CONTENT */}
          <div className="lg:col-span-2 space-y-6 text-slate-700 leading-7">

            <h1 className="text-3xl font-bold text-slate-900">
              Opt-Out from Targeted Advertising
            </h1>

            <p>
              You can opt-out from tracking and AdMatic’s unique cookie
              identifiers here. Click the button on the right and we will ensure
              that no tracking is applied to your browser.
            </p>

            <h2 className="text-xl font-semibold text-slate-900">
              Please be aware that:
            </h2>

            <ul className="list-decimal pl-6 space-y-3">
              <li>
                AdMatic needs to set an anonymous “opt-out” cookie to indicate
                your decision not to be tracked. Your opt-out remains valid as
                long as this cookie exists in your browser.
              </li>
              <li>
                Cookies are browser and device specific. Opting out on one
                browser or device does not apply to other devices or browsers.
              </li>
              <li>
                Some browsers such as Safari limit cookie functionality by
                default. In such cases your opt-out may not work as intended.
              </li>
              <li>
                After opting out, your existing data will be disassociated from
                your browser and device and will no longer be used for targeted
                advertising. You may still see ads but they may be less relevant.
              </li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 pt-4">
              Mobile Device Opt-Out
            </h2>

            <p>
              To opt-out of advertising tracking on mobile devices such as
              iPhones, Android devices or Smart TVs, please consult the settings
              of your device manufacturer.
            </p>

            <div className="space-y-4">

              <div className="border border-slate-200 rounded-xl p-5 bg-slate-50">
                <h3 className="font-semibold text-slate-900 mb-2">
                  Apple iOS
                </h3>
                <p>
                  Open <span className="font-medium">Settings → Privacy → Advertising</span> and
                  enable <span className="font-medium">Limit Ad Tracking</span>.
                </p>
                <p className="mt-2">
                  To reset your Advertising Identifier:
                  Settings → Privacy → Advertising → Reset Advertising Identifier.
                </p>
              </div>

              <div className="border border-slate-200 rounded-xl p-5 bg-slate-50">
                <h3 className="font-semibold text-slate-900 mb-2">
                  Android
                </h3>
                <p>
                  Open the Google Settings app → Ads → Reset advertising ID and
                  select <span className="font-medium">Opt-out of interest-based ads</span>.
                </p>
              </div>

            </div>

            <p>
              For more information about our privacy practices please review our{" "}
              <Link
                to="/user-agreement"
                className="text-blue-600 font-medium hover:underline"
              >
                Privacy Policy
              </Link>.
            </p>

          </div>

          {/* ACTION PANEL */}
          <div className="flex items-start lg:justify-center">
            <div className="w-full rounded-2xl border border-slate-200 bg-white p-8 shadow-sm text-center space-y-6">

              <h3 className="text-lg font-semibold text-slate-900">
                Tracking Preference
              </h3>

              <p className="text-sm text-slate-600">
                You can enable or disable advertising tracking for this browser.
              </p>

              <button
                onClick={toggleCookiePermission}
                className={`w-full py-3 rounded-lg font-semibold transition ${
                  cookiePermission === "1"
                    ? "bg-green-600 hover:bg-green-700 text-white"
                    : "bg-red-600 hover:bg-red-700 text-white"
                }`}
              >
                {cookiePermission === "1"
                  ? "Tracking Enabled"
                  : "Tracking Disabled"}
              </button>

              <p className="text-xs text-slate-500">
                Your preference will be stored using a cookie for 365 days.
              </p>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}